var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-settings" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "loading-wrapper" },
          [
            _c("a-skeleton", {
              attrs: { active: true, paragraph: { rows: 5 }, title: "" },
            }),
          ],
          1
        )
      : _vm.currentModule
      ? _c(
          "div",
          { staticClass: "route-page-content" },
          [
            _c("SidebarChild", {
              attrs: {
                items: _vm.menuItems,
                focusActive: true,
                selectedItem: _vm.selectedItem,
              },
              on: { selected: _vm.handleSidebarSelection },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-settings-page-content" },
              [
                _c("div", { staticClass: "title-wrapper" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v(_vm._s(_vm.currentModule.icon || "extension")),
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("modules.settings")) +
                        " - " +
                        _vm._s(_vm.currentModule.displayName)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "a-form",
                  {
                    staticClass: "module-settings-form",
                    attrs: { form: _vm.form, layout: "vertical" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.handleSubmit.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("modules.displayName") } },
                      [
                        _c("a-input", {
                          model: {
                            value: _vm.form.displayName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "displayName", $$v)
                            },
                            expression: "form.displayName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("modules.description") } },
                      [
                        _c("a-textarea", {
                          model: {
                            value: _vm.form.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "description", $$v)
                            },
                            expression: "form.description",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("modules.table") } },
                      [
                        _c(
                          "a-select",
                          {
                            attrs: {
                              allowClear: true,
                              placeholder: "Tablo Seçiniz",
                            },
                            model: {
                              value: _vm.form.table,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "table", $$v)
                              },
                              expression: "form.table",
                            },
                          },
                          _vm._l(_vm.tables, function (table) {
                            return _c(
                              "a-select-option",
                              { key: table._id, attrs: { value: table._id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(table.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("modules.menuApiSettings") } },
                      [
                        _c(
                          "a-checkbox",
                          {
                            model: {
                              value: _vm.form.settings.showInMainMenu,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form.settings,
                                  "showInMainMenu",
                                  $$v
                                )
                              },
                              expression: "form.settings.showInMainMenu",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("modules.showInMainMenu")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-checkbox",
                          {
                            model: {
                              value: _vm.form.settings.apiEnabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.form.settings, "apiEnabled", $$v)
                              },
                              expression: "form.settings.apiEnabled",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("modules.apiEnabled")))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("modules.icon") } },
                      [
                        _c("a-input", {
                          attrs: { placeholder: _vm.$t("modules.exampleIcon") },
                          model: {
                            value: _vm.form.icon,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "icon", $$v)
                            },
                            expression: "form.icon",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-form-item",
                      [
                        _c(
                          "a-button",
                          { attrs: { type: "primary", "html-type": "submit" } },
                          [_vm._v(_vm._s(_vm.$t("modules.save")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _c("div", { staticClass: "not-found" }, [
          _c("h3", [_vm._v("Modül bulunamadı.")]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }